import { Button, Label, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'

export const StyledLabel = styled(Label)`
  height: 18px;
`

export const StyledButton = styled(Button)`
  &[role='combobox'] {
    position: relative;
    height: 56px;
    padding-left: 8px;
    padding-right: 8px;
    &[aria-invalid='true'] {
      border-color: ${getPaletteColor('error.base')};
    }
    &[data-value='true'] {
      padding-top: 6px;
    }
  }
`
